import createRoute from '@widesk-ui/tools/createRoute';
import ClientModel from '@models/shop/ClientModel';

export default createRoute.dashboard('/clients', 'shop', 'ClientDashboard', ClientModel.localize());
